import { Page, Stack } from "@skailer-com/uikit";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface ConfigurePanelProps {
  children?: ReactNode;
}

export function ConfigurePanel({ children }: ConfigurePanelProps) {
  const { t } = useTranslation();

  return (
    <Stack className="w-56 shrink-0 h-full border-r bg-light/80">
      <Page.Header
        title={`${t("reporting:people_analytics_title")} - ${t("common:beta")}`}
        showBack={false}
      />
      <Stack className="px-4 pb-10 flex-1 min-h-0 overflow-y-auto" gap="md">
        {children}
      </Stack>
    </Stack>
  );
}
